import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { KwikstoreVisualEditorComponent } from './kwikstore-visual-editor.component';
import { NbMenuItem, NbSidebarModule } from '@nebular/theme';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { EditorsComponent } from './editors/editors/editors.component';
import { HomePageComponent } from './editors/home-page/home-page.component';
import { LayoutEditorComponent } from './editors/layout-editor/layout-editor.component';
import { HeaderEditorComponent } from './editors/header-editor/header-editor.component';
import { FooterEditorComponent } from './editors/footer-editor/footer-editor.component';
import { CategoryEditorComponent } from './editors/category-editor/category-editor.component';
import { ProductEditorComponent } from './editors/product-editor/product-editor.component';
import { ThemeEditorComponent } from './editors/theme-editor/theme-editor.component';
import { CartEditorComponent } from './editors/cart-editor/cart-editor.component';
import { BlogEditorComponent } from './editors/blog-editor/blog-editor.component';
import { AboutUsComponent } from './editors/about-us/about-us.component';
import { PoliciesEditorComponent } from './editors/policies-editor/policies-editor.component';
import { NavigationEditorComponent } from './editors/navigation-editor/navigation-editor.component';

export const routes: Routes = [
  {
    path: 'kve',
    component: KwikstoreVisualEditorComponent,
    children: [
      { path: 'layout', component: LayoutEditorComponent },
      { path: 'header', component: HeaderEditorComponent },
      { path: 'footer', component: FooterEditorComponent },
      { path: 'navigation', component: NavigationEditorComponent },
      { path: 'home-page', component: HomePageComponent },
      { path: 'category-page', component: CategoryEditorComponent },
      { path: 'product-page', component: ProductEditorComponent },
      { path: 'theme', component: ThemeEditorComponent },
      { path: 'cart', component: CartEditorComponent },
      { path: 'blog', component: BlogEditorComponent },
      { path: 'about-us', component: AboutUsComponent },
      { path: 'policies', component: PoliciesEditorComponent },
      { path: '', redirectTo: 'home-page', pathMatch: 'full' },
      /* children:[
        {
          path:'editors',
          loadChildren: () => import('./editors/editors.module')
          .then(m => m.EditorsModule),
        },
        { path: '', redirectTo: 'editors', pathMatch: 'full' },
      ], */
    ]
  },

  // { path: '', redirectTo: 'kve', pathMatch: 'full' },
  /* {
    path:'',redirectTo: 'kve', pathMatch: 'full'}, */
];
const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Stores',
    icon: 'cube-outline',
    link: '/admin/pms/stores',
  },
  {
    title: 'Catalog',
    icon: 'globe-outline',
    link: '/admin/pms/catalog',
    home: true,
  },
  {
    title: 'Categories',
    icon: 'file-text-outline',
    link: '/admin/pms/categories',
    home: true,
  },
  {
    title: 'Configurations',
    icon: 'clipboard-outline',
    link: '/admin/pms/configurations',
  },
  {
    title: 'Features',
    icon: 'book-outline',
    link: '/admin/pms/features',
  },
  {
    title: 'Image Management',
    icon: 'people-outline',
    link: '/admin/pms/image-management',
  },
  {
    title: 'Price Rules',
    icon: 'cube-outline',
    link: '/admin/pms/price-rules',
  },
  {
    title: 'Product Store Groups',
    icon: 'color-palette-outline',
    link: '/admin/pms/product-store-groups',
  },
  {
    title: 'Products',
    icon: 'book-outline',
    link: '/admin/pms/products',
  },
  {
    title: 'Promos',
    icon: 'people-outline',
    link: '/admin/pms/promos',
  },
  {
    title: 'Reviews',
    icon: 'cube-outline',
    link: '/admin/pms/reviews',
  },
  {
    title: 'Shipping',
    icon: 'color-palette-outline',
    link: '/admin/pms/shipping',
  },
  {
    title: 'Thesaurus',
    icon: 'color-palette-outline',
    link: '/admin/pms/thesaurus',
  },
];
const headerTitle: string = "KVE";
const menuAndTitleOptions = { path: "kve", menuItems: MENU_ITEMS, headerTitle: headerTitle };
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UbsViewContainersModule,
    RouterModule.forChild(routes),
    NbSidebarModule.forRoot(),
  ],
  exports: [RouterModule, UbsViewContainersModule]
})
export class KveRoutingModule {
  /* constructor(private viewContainerService:ViewContainersService){
    this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)

  } */
}
